import Vue from "vue";
//import { Api } from '../../plugins/api';
import axios from "axios";

// Mise en place d'axios
axios.defaults.baseURL = process.env.VUE_APP_BASE_API_URL;
Vue.prototype.$http = axios;

Vue.prototype.$StoreAnnexesInscrUm6p = {
  ListeAnnexesFirsi: [],
  // RÃ©cuperer liste fichiers
  ChargerListeAnnexesInscription(token) {
    return axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .get("um6p/GetAnnexes");
  },
  ChargerListeAnnexesResultatBac(token, id) {
    return axios
      .create({
        baseURL: process.env.VUE_APP_BASE_API_URL,
        withCredentials: false,
        headers: {
          Accept: "application/json",
          token: token,
        },
      })
      .get("resultatbac/GetAnnexes/" + id);
  },
  MapperListe(listeAnnexes){
    this.ListeAnnexesFirsi = [];
    listeAnnexes.forEach(element=>{
      var annexe = this.ElementToAnnexesFirsiDto(element);

      this.ListeAnnexesFirsi.push(annexe);
    });
  },
  SortListe(listeAnnexes){
    return listeAnnexes.sort((a, b) => {
      const priorityCodes = ['CNIE', 'PHIDENTITE', 'LR1', 'LR2'];
      const codeA = a.nomDocument && a.nomDocument.code != "" ? a.nomDocument.code : null;
      const codeB = b.nomDocument && b.nomDocument.code != "" ? b.nomDocument.code : null;
      const indexA = priorityCodes.indexOf(codeA);
      const indexB = priorityCodes.indexOf(codeB);
      if (indexA !== -1 && indexB === -1) return -1; 
      if (indexA === -1 && indexB !== -1) return 1;
      if (indexA !== -1 && indexB !== -1) return indexA - indexB;
      return 0;
    });
  },
  ElementToAnnexesFirsiDto(element) {
    var annexe = {
      Editable: element.editable,
      Deadline: element.deadline,
      Supprimer: false,
      IdCrypte: element.idCrypte,
      ObligatoireSoumettre: element.obligatoireSoumettre,
      LabelFormulaire: element.labelFormulaire ?? element.nomDocument?.lang00,
      AnneeScolaire: {
        Id: element.anneeScolaire?.id,
        Lang00: element.anneeScolaire?.lang00,
        Lang01: element.anneeScolaire?.lang01,
      },
      ConformiteElectronique: {
        Id: element.conformiteElectronique?.id,
        Lang00: element.conformiteElectronique?.lang00,
        Lang01: element.conformiteElectronique?.lang01,
      },
      ConformitePhysique: {
        Id: element.conformitePhysique?.id,
        Lang00: element.conformitePhysique?.lang00,
        Lang01: element.conformitePhysique?.lang01,
      },
      NatureDocument: {
        Id: element.natureDocument?.id,
        Lang00: element.natureDocument?.lang00,
        Lang01: element.natureDocument?.lang01,
      },
        NomDocument:{
            Id : element.nomDocument?.id,
            Lang00 : element.nomDocument?.lang00,
            Lang01 : element.nomDocument?.lang01,
            Code : element.nomDocument?.code,
        },
        NomFichier:element.nomFichier,
        DonneePieceJointe:element.donneePieceJointe,
        NonConformeElectronique:element.nonConformeElectronique,
        NonConformePhysique:element.nonConformePhysique,
        DossierBourseId:element.dossierBourseId,
        PpId:element.ppId,
        TemplateAnnexeFirsi:element.templateAnnexeFirsi,
        TypeDeDocument:{
            Id : element.typeDeDocument?.id,
            Lang00 : element.typeDeDocument?.lang00,
            Lang01 : element.typeDeDocument?.lang01,
      
      },
      UrlFichier: element.urlFichier,
    };

    return annexe;
  },
  ItemLang: "Lang00",
  Label: {
    TailleMaximale: "Taille maximum du fichier : 8Mo",
    TailleMaximaleDepassee: "Taille maximale du fichier dépassée.",
    AjouterPieceJointe: "Ajouter une pièce jointe",
    TypePiece: "Type de pièces",
    SelectionnerDocument: "Sélectionner votre document",
    FormatsAcceptes: "Formats acceptés : pdf et images (jpg, jpeg et png)",
    FormatsAcceptesPdf: "Formats acceptés : pdf uniquement",
    FichierSelectionne: "Fichier sélectionné",
    Annuler: "Annuler",
    Valider: "Valider",
    ListeVide: "La liste est vide",
    FichierManquant: "Fichier manquant",
    Oui: "Oui",
    Non: "Non",
    AfficherDocument: "Afficher le document",
    Headers: [
      { text: "Type de pièces", value: "type", sortable: false },
      { text: "Fichiers", value: "fichier", sortable: false },
      { text: "Obligatoire (Oui/Non)", value: "obligatoire", sortable: false },
      {
        text: "Conformité électronique",
        value: "conformiteelectronique",
        sortable: false,
      },
      { text: "Remarques", value: "noteconformiteelectronique", sortable: false },
      { text: "Deadline", value: "deadline", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    HeadersPhone: [
      { text: "Type de pièces", value: "type", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
      { text: "Fichiers", value: "fichier", sortable: false },
      { text: "Obligatoire (Oui/Non)", value: "obligatoire", sortable: false },
      {
        text: "Conformité électronique",
        value: "conformiteelectronique",
        sortable: false,
      },
      { text: "Remarques", value: "noteconformiteelectronique", sortable: false },
      { text: "Deadline", value: "deadline", sortable: false },
    ],
  },
  LabelFR: {
    TailleMaximale: "Taille maximum du fichier : 8Mo",
    TailleMaximaleDepassee: "Taille maximale du fichier dépassée.",
    AjouterPieceJointe: "Ajouter une pièce jointe",
    TypePiece: "Type de pièces",
    SelectionnerDocument: "Sélectionner votre document",
    FormatsAcceptes: "Formats acceptés : pdf et images (jpg, jpeg et png)",
    FormatsAcceptesPdf: "Formats acceptés : pdf uniquement",
    FichierSelectionne: "Fichier sélectionné",
    Annuler: "Annuler",
    Valider: "Valider",
    ListeVide: "La liste est vide",
    FichierManquant: "Fichier manquant",
    Oui: "Oui",
    Non: "Non",
    AfficherDocument: "Afficher le document",
    Headers: [
      { text: "Type de pièces", value: "type", sortable: false },
      { text: "Fichiers", value: "fichier", sortable: false },
      { text: "Obligatoire (Oui/Non)", value: "obligatoire", sortable: false },
      {
        text: "Conformité électronique",
        value: "conformiteelectronique",
        sortable: false,
      },
      { text: "Remarques", value: "noteconformiteelectronique", sortable: false },
      { text: "Deadline", value: "deadline", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    HeadersPhone: [
      { text: "Type de pièces", value: "type", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
      { text: "Fichiers", value: "fichier", sortable: false },
      { text: "Obligatoire (Oui/Non)", value: "obligatoire", sortable: false },
      {
        text: "Conformité électronique",
        value: "conformiteelectronique",
        sortable: false,
      },
      { text: "Remarques", value: "noteconformiteelectronique", sortable: false },
      { text: "Deadline", value: "deadline", sortable: false },
    ],
  },
  LabelEN: {
    TailleMaximale: "Maximum file size: 4MB",
    TailleMaximaleDepassee: "Maximum file size exceeded.",
    AjouterPieceJointe: "Add a file",
    TypePiece: "Type of documents",
    SelectionnerDocument: "Select your document",
    FormatsAcceptes: "Accepted formats : pdf et images (jpg, jpeg et png)",
    FormatsAcceptesPdf: "Accepted formats: pdf only",
    FichierSelectionne: "Selected file",
    Annuler: "Cancel",
    Valider: "Confirm",
    ListeVide: "The list is empty",
    FichierManquant: "Missing file",
    Oui: "Yes",
    Non: "No",
    AfficherDocument: "View document",
    Headers: [
      { text: "Type of documents", value: "type", sortable: false },
      { text: "Files", value: "fichier", sortable: false },
      { text: "Required (Yes/No)", value: "obligatoire", sortable: false },
      {
        text: "Electronic conformity",
        value: "conformiteelectronique",
        sortable: false,
      },
      { text: "Remarks", value: "noteconformiteelectronique", sortable: false },
      { text: "Deadline", value: "deadline", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
    ],
    HeadersPhone: [
      { text: "Type of documents", value: "type", sortable: false },
      { text: "Actions", value: "actions", sortable: false },
      { text: "Files", value: "fichier", sortable: false },
      { text: "Required (Yes/No)", value: "obligatoire", sortable: false },
      {
        text: "Electronic conformity",
        value: "conformiteelectronique",
        sortable: false,
      },
      { text: "Remarks", value: "noteconformiteelectronique", sortable: false },
      { text: "Deadline", value: "deadline", sortable: false },
    ],
  },
};
